import { Box } from '@mui/material';
import React from 'react';

import { TimesheetHeader } from '@/widgets/TimesheetHeader';

import { Sidebar } from './Sidebar';

interface LayoutProps {
  children: React.ReactNode;
}

const Layout: React.FC<LayoutProps> = ({ children }) => {
  return (
    <Box sx={{ display: 'flex', height: '100vh' }}>
      <Sidebar />
      <Box
        sx={{ display: 'flex', flexDirection: 'column', flex: 1, minWidth: 0, overflow: 'hidden' }}
      >
        <TimesheetHeader />
        <Box sx={{ flex: 1, minHeight: 0, overflow: 'hidden' }}>{children}</Box>
      </Box>
    </Box>
  );
};

export default Layout;
